"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeHero = void 0;
var React = require("react");
var GoogleMap_1 = require("@/api/vendor/GoogleMap");
var PlaceState_1 = require("@/pages/place/states/PlaceState");
var PlaceGallery_1 = require("@/pages/place/components/PlaceGallery");
var MapLocation_1 = require("@/pages/common/components/MapLocation");
exports.placeHero = function (props) {
    var miniGalleryClass = 'o-link o-link--nounder o-link--contrast u-stretch u-flex u-flex--middle';
    // tslint:disable-next-line:max-line-length
    var staticMap = "https://maps.googleapis.com/maps/api/staticmap?center=" + props.lat + "," + props.lng + "&zoom=16&size=150x180&markers=color:0x00b0a8|" + props.lat + "," + props.lng + "&maptype=roadmap&style=feature:all|element:labels|visibility:off&key=" + props.googleApikey;
    // tslint:disable-next-line:max-line-length
    var staticSatelliteMap = "https://maps.googleapis.com/maps/api/staticmap?center=" + props.lat + "," + props.lng + "&zoom=16&size=150x180&markers=color:0x00b0a8|" + props.lat + "," + props.lng + "&maptype=satellite&style=feature:all|element:labels|visibility:off&key=" + props.googleApikey;
    var showMap = function (type) { return function () {
        props.showPop(PlaceState_1.GalleryPopState.MAP);
        props.setMapType(type);
    }; };
    var showPop = function (popState) { return function () {
        return props.showPop(popState);
    }; };
    var hasPhoto = props.galleryItems.length ? true : false;
    var hasLatLng = props.lat && props.lng ? true : false;
    var renderMiniGalleryButton = function (props) { return (React.createElement("a", { id: "prop-mini-gallery-btn", onClick: showPop(PlaceState_1.GalleryPopState.THUMBS), className: "u-pointer-event--all o-minibox" },
        React.createElement("div", { className: miniGalleryClass },
            React.createElement("span", { className: "u-text-center" },
                React.createElement("span", { className: "fal fa-images", style: { lineHeight: '24px' } }),
                React.createElement("br", null),
                React.createElement("span", { id: "prop-photo-count", className: "u-mobile-hidden" },
                    props.galleryItems.length,
                    " ",
                    props.t.photos))))); };
    var renderMiniMapButton = function (props) {
        var map = hasPhoto ? staticMap : staticSatelliteMap;
        var type = hasPhoto ? GoogleMap_1.GoogleMapType.ROADMAP : GoogleMap_1.GoogleMapType.SATELLITE;
        return (React.createElement("a", { id: "prop-minimap-btn", onClick: showMap(type), className: "u-pointer-event--all o-minibox", href: "#", style: { alignItems: 'flex-start' } },
            React.createElement("img", { id: "prop-minimap-img", className: "o-image", src: map, alt: props.name + " map" })));
    };
    var renderMiniButtons = function (props) {
        return (React.createElement("div", { className: "u-anchor-bottom u-pointer-event--none" },
            React.createElement("div", { className: "l-container l-container--lr" },
                React.createElement("div", { className: "l-container__main u-flex-right" },
                    hasPhoto ? renderMiniGalleryButton(props) : '',
                    hasLatLng ? renderMiniMapButton(props) : ''))));
    };
    var onGalleryItemClick = function (item) {
        props.onGalleryItemClicked(item.src);
    };
    var onSlideIndexChanged = function (index) {
        props.setGalleryIndex(index);
    };
    var renderMainGallery = function (props) { return (React.createElement("div", { id: "maingallery", style: { backgroundColor: '#ccc' } },
        React.createElement(PlaceGallery_1.PlaceGalleryComponent, { width: '100%', height: '100%', items: props.galleryItems, slideIndex: props.galleryIndex, onItemClick: onGalleryItemClick, onSlideIndexChanged: onSlideIndexChanged }))); };
    var renderBigMap = function (props) {
        var mapProp = {
            mapType: GoogleMap_1.GoogleMapType.ROADMAP,
            id: 'big-place-map',
            name: props.name,
            lat: props.lat,
            lng: props.lng,
        };
        return (React.createElement("div", { id: "props-big-map", style: { height: '500px' } },
            React.createElement(MapLocation_1.default, __assign({}, mapProp))));
    };
    var renderNoPhoto = function (props) {
        return (React.createElement("div", { id: "prop-nophoto", className: "c-hero__nopic" }, props.t.noPhoto));
    };
    return (React.createElement("div", { id: "prop-hero", className: "u-relative" },
        hasPhoto ? renderMainGallery(props) : '',
        !hasPhoto && hasLatLng ? renderBigMap(props) : '',
        hasPhoto || hasLatLng ? renderMiniButtons(props) : '',
        !hasPhoto && !hasLatLng ? renderNoPhoto(props) : ''));
};
